import * as React from 'react'

const SvgPauseFilledIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 4.5H7.5A1.5 1.5 0 006 6v12a1.5 1.5 0 001.5 1.5H9a1.5 1.5 0 001.5-1.5V6A1.5 1.5 0 009 4.5zm7.5 0H15A1.5 1.5 0 0013.5 6v12a1.5 1.5 0 001.5 1.5h1.5A1.5 1.5 0 0018 18V6a1.5 1.5 0 00-1.5-1.5z"
      fill="#163250"
    />
  </svg>
)

export default SvgPauseFilledIcon
